import { Controller } from "@hotwired/stimulus"
import { jsonHeader } from '../jssrc/base_ext.js';
import { disp_xhr_error} from '../jssrc/ui_tweak.js';
import i18n from '../jssrc/i18n_js_with_locales';

export default class extends Controller {
    child(selector) {
	return this.element.querySelector(selector);
    }

    on_post_success(event){
	const [data, status, xhr] = event.detail;
	this.append_to_email_log(data);
	$.jqmodal.close();
    }

    on_post_error(event){
	const [data, status, xhr] = event.detail;
	disp_xhr_error(this, xhr);
    }

    append_to_email_log(email){
	// $('#email-log table tbody:last-child').append($('<tr>')
	// 						  .append($('<td>').append(email.created_at))
	// 						  .append($('<td>').append(email.subject)));
	alert(i18n.t('flash.sent_succ'));
    }

    async rebuild_email(){
	let template_id = this.child('#communication_template_id').value;
	if (template_id){
	    const response = await this.build_email_by(template_id);
	    await this.bind_email_template(response);
	}
    }

    async build_email_by(id){
	let candidate_id = this.child('#candidate_id').value;
	return fetch(`/communications/new?candidate=${candidate_id}&template=${id}`, {
	    method: 'GET',
	    headers: jsonHeader()
	});
    }

    async bind_email_template(response){
	if (response.ok) {
	    const comm = await response.json();
	    this.child('#communication_body').value = comm.body;
	    this.child('#communication_responder_addr').value = comm.responder_addr;
	    this.child('#communication_carbon_copy').value = comm.carbon_copy;
	    this.child('#communication_subject').value = comm.subject;
	    this.child('#communication_thread_token').value = comm.thread_token;
	}else{
	    const errors = await response.json();
	    disp_xhr_error('#new_communication', errors);
	}
    }
}
